export enum AnnouncementType {
  ReservationCreated = 'ReservationCreated',
  ReservationCreationFailed = 'ReservationCreationFailed',
  ReservationOutsideHours = 'ReservationOutsideHours',
  ReservationUpdated = 'ReservationUpdated',
  ReservationUpdateFailed = 'ReservationUpdateFailed',
  ReservationCanceled = 'ReservationCanceled',
  ReservationCancelFailed = 'ReservationCancelFailed',
  ReservationStateUpdated = 'ReservationStateUpdated',
  ReservationStateUpdateFailed = 'ReservationStateUpdateFailed',
  FeedbackReceived = 'FeedbackReceived',
  FeedbackFailed = 'FeedbackFailed',
  ContactSaved = 'ContactSaved',
  ReservationSettingSaved = 'ReservationSettingSaved',
  ProfileSaved = 'ProfileSaved',
  LayoutSaved = 'LayoutSaved',
  EmployeeUpdated = 'EmployeeUpdated',
  EmployeeUpdateFailed = 'EmployeeUpdateFailed',
}

export default AnnouncementType;
